import '@babel/polyfill';
import 'top20common/node_modules/vue-svgicon/polyfill';
import '@/assets/js/polyfills/removeNodes';
import 'buefy/lib/buefy.css';

import Buefy from 'buefy';
import cssVars from 'css-vars-ponyfill';
import SvgIcon from 'top20common/components/SvgIcon';
import {browser} from 'top20common/distribution/plugins/browserDetermine';
import {context} from 'top20common/distribution/plugins/context';
import {icons} from 'top20common/distribution/plugins/dynamicallyIconsPath';
import {language} from 'top20common/distribution/plugins/language';
import PosthogModule from 'top20common/distribution/plugins/posthog';
import cssVarsConfig from 'top20common/distribution/themes/config';
import {getGAKeyByContext} from 'top20common/distribution/themes/utils';
import utils from 'top20common/distribution/utils';
import VSwipe from 'vswipe';
import Vue from 'vue';
import VueCookie from 'vue-cookie';
import GetTextPlugin from 'vue-gettext';
import VModal from 'vue-js-modal';
import MQ from 'vue-match-media/src';
import VueMultianalytics from 'vue-multianalytics';
import Router from 'vue-router';

import analyticsPlugin from '@/plugins/analytics';

import translations from '../../translations.json';
import App from './App';
import router from './router';
import store from './store';

cssVars({...cssVarsConfig});

Vue.use(Router);
Vue.use(VueCookie);
Vue.use(language);
Vue.use(context);
Vue.use(GetTextPlugin, {
  availableLanguages: {
    en_US: 'English',
    zh_Hans: 'Chinese'
  },
  defaultLanguage: 'en_US',
  translations: translations,
  silent: true
});

Vue.use(icons);
Vue.use(MQ);
Vue.use(Buefy);
Vue.use(VSwipe);
Vue.use(browser);

const gaConfig = {
  appName: `CGP O2O FE`,
  appVersion: '1.0',
  trackingId: getGAKeyByContext(),
  debug: process.env.NODE_ENV !== 'production'
};

VueMultianalytics.addCustomModule('posthog', PosthogModule);

const analyticsModules = {
  ga: gaConfig,
  posthog: {}
};

Vue.use(VueMultianalytics, {modules: analyticsModules}, analyticsPlugin);
Vue.component('svg-icon', SvgIcon);
Vue.use(VModal);

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App},
  mq: {
    phone: '(max-width: 768px)',
    tablet: '(max-width: 1023px)',
    desktop: '(min-width: 1024px)'
  }
});

utils.setVueForUtils(app);
